<template>
  <el-table :data="list" border style="width: 100%" height="100%" v-loading="loading">
    <el-table-column
      type="index"
      width="50"
      align="center"
    ></el-table-column>
    <el-table-column prop="title" align="center" label="标题"></el-table-column>
    <el-table-column align="center" label="人员信息">
      <template slot-scope="scope">
        <div>创建人: {{ scope.row.creater }}</div>
        <div>更新人: {{ scope.row.modifier }}</div>
      </template>
    </el-table-column>
    <el-table-column label="时间信息" align="center">
      <template slot-scope="scope">
        <div>创建时间: {{ scope.row.createDate | dateFormat }}</div>
        <div>发送时间: {{ scope.row.sendTime | dateFormat }}</div>
        <div>更新时间: {{ scope.row.modifyDate | dateFormat }}</div>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <el-button
          @click="editRow(scope.row)"
          type="text"
          size="small"
          style="margin-right: 8px"
          >编辑</el-button
        >
        <el-popconfirm
          title="确定删除此条数据吗"
          icon-color="red"
          @confirm="deleteRow(scope.row)"
        >
          <el-button
            slot="reference"
            type="text"
            size="small"
            style="color: red"
            >删除</el-button
          >
        </el-popconfirm>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import API from "@/api"
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    loading:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    deleteRow(row) {
      const params = new FormData()
      params.append("id", row.id)
      API.newFunctionDeleteStationLetter(params).then(() => {
        this.$message.success("删除成功")
        this.$emit('deleteRow')
      })
    },
    editRow(row) {
      this.$router.push({
        path: "/operation/newFunction/add",
        query: {
          id: row.id,
        },
      })
    },
  }
}
</script>

<style lang="scss" scoped>
</style>